import Vue from 'vue'

import ModalAlertContainer from '@/components/modalAlertContainer'
import ModalContainer from '@/components/modalContainer'

import TermsModal from '@/components/pages/termsModal'
import PrivacyModal from '@/components/pages/privacyModal'
import AddressModal from '@/components/pages/addressModal'
import ManagerNoticeModal from '@/components/pages/managerNoticeModal'

Vue.component(ModalAlertContainer.name, ModalAlertContainer)
Vue.component(ModalContainer.name, ModalContainer)

Vue.component(TermsModal.name, TermsModal)
Vue.component(PrivacyModal.name, PrivacyModal)
Vue.component(AddressModal.name, AddressModal)
Vue.component(ManagerNoticeModal.name, ManagerNoticeModal)
